import { StyledIconWrapper } from "./styled"
import { IIconWrapperProps } from "./types"

const IconWrapper = ({children, color = "primary"}:IIconWrapperProps)=>{
    return (
        <StyledIconWrapper customColor={color}>
            {children}
        </StyledIconWrapper>
    )
}

export {IconWrapper}